// extracted by mini-css-extract-plugin
export default {"link":"nE-z","disabled":"oE-z"};